import httpService from '@/services/httpService'
import { convertAdvancedOptionsToURLParams, findUrlBiId } from '@/store/modules/rank-zone/Helper'
// eslint-disable-next-line no-unused-vars
import Status from '../../../features/reports/rank-zone/status/Status'

export const types = {
  ADD_SHARE_OF_VOICE_DATA: 'rank-zone/ADD_SHARE_OF_VOICE_DATA',
  ADD_MSV_DATA: 'rank-zone/ADD_MSV_DATA',
  ADD_STATUSES_DATA: 'rank-zone/ADD_STATUSES_DATA',
  ADD_STATUSES_KEYWORDS_DATA: 'rank-zone/ADD_STATUSES_KEYWORDS_DATA',
  ADD_STATUSES_TOTALS_DATA: 'rank-zone/ADD_STATUSES_TOTALS_DATA',
  RESET_STATUSES_DATA: 'rank-zone/RESET_STATUSES_DATA'
}

const state = {
  share_of_voice: [],
  monthly_search_volume: [],
  unfiltered_totals: {},
  statuses: []
}

const mutations = {
  [ types.ADD_SHARE_OF_VOICE_DATA ]: function (state, payload) {
    state.share_of_voice = payload
  },
  [ types.ADD_MSV_DATA ]: function (state, payload) {
    state.monthly_search_volume = payload
  },
  [ types.ADD_STATUSES_DATA ]: function (state, payload) {
    state.statuses = payload
  },
  [ types.ADD_STATUSES_TOTALS_DATA ]: function (state, payload) {
    state.unfiltered_totals = payload
  },
  [ types.RESET_STATUSES_DATA ]: function (state) {
    state.share_of_voice = []
    state.monthly_search_volume = []
    state.statuses = []
    state.unfiltered_totals = {}
  },
  [ types.ADD_STATUSES_KEYWORDS_DATA ]: function (state, { keywords, urlId }) {
    const url = findUrlBiId(state.statuses, urlId)
    if (url) {
      url.children = keywords
    }
  }
}

const loadStatusData = async function (clientId, filters) {
  const msv = JSON.parse(localStorage.getItem('msv')) || {}
  filters.msv = msv[clientId] || 1
  if (filters && filters.advancedFilters) {
    const params = convertAdvancedOptionsToURLParams(filters)
    return httpService.get(`/reports/rankzone-report/status/${clientId}`, { params: params }, { encode: false })
  }
  return httpService.get(`/reports/rankzone-report/status/${clientId}`, { params: filters })
}

const actions = {
  getStatusData: async function ({ commit, dispatch }, { clientId, filters }) {
    const status = await loadStatusData(clientId, filters)
    if (!status || !status.data) {
      return
    }
    commit(types.ADD_MSV_DATA, status.data[ 'monthly_search_volume' ])
    commit(types.ADD_SHARE_OF_VOICE_DATA, status.data[ 'share_of_voice' ])
    commit(types.ADD_STATUSES_DATA, status.data[ 'statuses' ])
    commit(types.ADD_STATUSES_TOTALS_DATA, status.data[ 'unfiltered_totals' ])

    return status
  },
  resetData ({ commit }) {
    commit(types.RESET_STATUSES_DATA)
  },
   /**
   * set keywords for expanded row in table
   * @param payload received from {@link getKeywordsByUrlIdData()}
   */
  setKeywords ({ commit, dispatch }, payload) {
    commit(types.ADD_STATUSES_KEYWORDS_DATA, payload)
  }
}

/**
 * Store keep data for {@link Status} component
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
